export class AppConstants {
    public static fallbackLanguageCode = 'en-us';
    public static fallbackCountryCode = 'usa';
    public static fallbackPath = 'usa/en-us/home';
    public static DEFULT_PROFILEIMG = 'https://x1.xingassets.com/assets/frontend_minified/img/users/nobody_m.original.jpg';
}